import { createSlice } from '@reduxjs/toolkit'

const updatedOnSliceV2 = createSlice({
  name: 'creditUpdatedOnV2',
  initialState: null, // Initial value of updatedOn
  reducers: {
    setCreditUpdatedOnV2: (state, action) => action.payload
  }
})

export const { setCreditUpdatedOnV2 } = updatedOnSliceV2.actions

export default updatedOnSliceV2.reducer
